type AppConfig = {
  apiBaseUrl: string;
  cognitoRegion: string;
  cognitoUserPoolId: string;
  cognitoClientId: string;
  cognitoDomain: string;
  cognitoScopes: string;
};

/**
 * All config comes from VITE_* env vars, set at build time via .env files.
 *
 * Required vars (see .env.development / .env.production):
 *   VITE_API_BASE_URL
 *   VITE_COGNITO_REGION
 *   VITE_COGNITO_USER_POOL_ID
 *   VITE_COGNITO_CLIENT_ID
 *   VITE_COGNITO_DOMAIN
 *   VITE_COGNITO_SCOPES  (e.g. "openid+email+profile")
 */
export const config: AppConfig = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || "",
  cognitoRegion: import.meta.env.VITE_COGNITO_REGION || "",
  cognitoUserPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || "",
  cognitoClientId: import.meta.env.VITE_COGNITO_CLIENT_ID || "",
  cognitoDomain: import.meta.env.VITE_COGNITO_DOMAIN || "",
  cognitoScopes: import.meta.env.VITE_COGNITO_SCOPES || "openid+email+profile",
};
